import { useMemo, useState } from 'react';
import VirtualList from 'react-tiny-virtual-list';

import { DetailsPlayerSubmit } from '../Team/DetailsPlayer';

import { ItemAssistant } from './ItemsAssistant';

import { Paginator } from '@/components/Paginator';
import { useGetFieldAssistantData } from '@/hooks/useFieldAssistant';
import { useIsDesktop } from '@/hooks/useIsDesktop';
import { usePlayerTemplateMap } from '@/hooks/usePlayer';
import { Mas } from '@/types/fieldAssistance';
import { EMPTY_TEMPLATE_PLAYER } from '@/utils';

const ITEMS_PER_PAGE = 10;

interface Props {
  activeTab: number;
  handleTransferAssistante?: (data: DetailsPlayerSubmit, pin?: string) => void;
}

export const ReplacementsTable = ({ activeTab }: Props) => {
  const { isMobile } = useIsDesktop();
  const { dataDinamics } = useGetFieldAssistantData();
  const playerMap = usePlayerTemplateMap();

  const [paginatedData, setPaginatedData] = useState<Mas[]>([]);
  const [, setCurrentPageNumber] = useState(0);

  const data = useMemo(() => {
    if (!dataDinamics) return [];
    return activeTab === 0
      ? dataDinamics.masElegidosFecha || []
      : dataDinamics.masReemplazados || [];
  }, [dataDinamics, activeTab]);

  const renderItem = (item: Mas) => {
    const templatePlayer = playerMap.get(item.idJT) || {
      ...EMPTY_TEMPLATE_PLAYER,
      id: item.idJT,
      n: item.nombre || 'Unknown',
      a: 'Player',
    };

    return (
      <div key={item.idJT} className="flex items-center">
        <div className="flex-1">
          <ItemAssistant.Replacements
            dataPlayerFieldAssistance={item}
            templatePlayer={templatePlayer}
            type={activeTab === 0 ? 'ENTRADAS' : 'SALIDAS'}
          />
        </div>
      </div>
    );
  };

  if (!data || data.length === 0) {
    return <div className="p-4 text-center">No hay datos disponibles.</div>;
  }

  return (
    <div className="w-full">
      {isMobile ? (
        <VirtualList
          height={500}
          itemCount={data.length}
          itemSize={83}
          renderItem={({
            index,
            style,
          }: {
            index: number;
            style: React.CSSProperties;
          }) => {
            const item = data[index];
            const templatePlayer = playerMap.get(item.idJT) || {
              ...EMPTY_TEMPLATE_PLAYER,
              id: item.idJT,
              n: item.nombre || 'Unknown',
              a: 'Player',
            };

            return (
              <div
                key={item.idJT}
                className="flex items-center mt-6"
                style={style}
              >
                <div className="flex-1">
                  <ItemAssistant.Replacements
                    dataPlayerFieldAssistance={item}
                    templatePlayer={templatePlayer}
                    type={activeTab === 0 ? 'ENTRADAS' : 'SALIDAS'}
                  />
                </div>
              </div>
            );
          }}
          width="100%"
        />
      ) : (
        <>
          <div className="flex flex-col mt-6">
            {(data.length > ITEMS_PER_PAGE ? paginatedData : data).map((item) =>
              renderItem(item)
            )}
          </div>
          {data.length > ITEMS_PER_PAGE && (
            <div className="mt-4 flex justify-center">
              <Paginator
                currentContentPage={(items) => setPaginatedData(items as Mas[])}
                currentNumberPage={setCurrentPageNumber}
                items={data}
                itemsPerPage={ITEMS_PER_PAGE}
              />
            </div>
          )}
        </>
      )}
    </div>
  );
};
